import { useState } from "react"
import { FaChevronDown, FaChevronRight, FaExternalLinkAlt, FaUser, FaKey } from "react-icons/fa"
import { toast } from "react-toastify"
import Tooltip from "../../../components/ui/ToolTip"

const LateralMenuButtonSubCategory = ({ item }) => {

  const [open, setOpen] = useState(false)
  const [copiedKey, setCopiedKey] = useState(null)

  const hasChildren = item.subCategoryLinks && item.subCategoryLinks.length > 0

  const handleClick = () => {
    if (hasChildren) {
      setOpen(!open)
    } else if (item.itemLink) {
      window.open(item.itemLink, "_blank", "noopener,noreferrer")
    }
  }

  const handleCopy = (text, key) => {
    navigator.clipboard.writeText(text)
    setCopiedKey(key)
    setTimeout(() => setCopiedKey(null), 1500)
    toast.success("Copiado al portapapeles")
  }

  return (
    <div className="flex flex-col">
      <button
        className="flex items-center justify-between w-full px-3 py-2.5 text-xs font-semibold text-gray-700 hover:bg-gray-100 rounded-lg transition-all duration-150"
        onClick={handleClick}
      >
        <span className="truncate">{item.itemName}</span>
        {hasChildren ? (
          open 
            ? <FaChevronDown className="text-[10px] text-gray-400 shrink-0 ml-2" /> 
            : <FaChevronRight className="text-[10px] text-gray-400 shrink-0 ml-2" />
        ) : item.itemLink ? (
          <FaExternalLinkAlt className="text-[9px] text-gray-400 shrink-0 ml-2" />
        ) : null}
      </button>

      {open && item.subCategoryLinks && item.subCategoryLinks.length > 0 && (
        <div className="flex flex-col ml-3 pl-3 border-l-2 border-gray-200 gap-0.5 py-1">
          {item.subCategoryLinks.map((e, i) => (
            <div key={i} className="flex items-center gap-0.5">
              <a
                href={e.itemLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-3 py-2 text-xs text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-all duration-150 flex-1 min-w-0"
              >
                <FaExternalLinkAlt className="text-[9px] shrink-0" />
                <span className="truncate">{e.itemName}</span>
              </a>
              {e.user && (
                <div>
                  <Tooltip content="Copiar usuario">
                    <button
                      onClick={() => handleCopy(e.user, `user-${i}`)}
                      className={`shrink-0 p-1.5 rounded-md transition-all duration-150 ${
                        copiedKey === `user-${i}` 
                          ? 'text-green-600 bg-green-50' 
                          : 'text-gray-400 hover:text-blue-600 hover:bg-blue-50'
                      }`}
                      title={copiedKey === `user-${i}` ? "¡Copiado!" : `Copiar usuario`}
                    >
                      <FaUser className="text-[9px]" />
                    </button>
                  </Tooltip>

                </div>
              )}
              {e.password && (
                <div>
                  <Tooltip content="Copiar contraseña">
                    <button
                      onClick={() => handleCopy(e.password, `pass-${i}`)}
                      className={`shrink-0 p-1.5 rounded-md transition-all duration-150 ${
                        copiedKey === `pass-${i}` 
                          ? 'text-green-600 bg-green-50' 
                          : 'text-gray-400 hover:text-amber-600 hover:bg-amber-50'
                      }`}
                      title={copiedKey === `pass-${i}` ? "¡Copiado!" : `Copiar contraseña`}
                    >
                      <FaKey className="text-[9px]" />
                    </button>
                  </Tooltip>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default LateralMenuButtonSubCategory
